export default "__VITE_ASSET__910eaa33__"